import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import translate_pt from './translations/translate_pt';
import translate_en from './translations/translate_en';
import translate_es from './translations/translate_es';

const resources: Resource = {
  'pt-BR': translate_pt,
  en: translate_en,
  es: translate_es
};

void i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
